<template>
    <div class="sign-up">
        <p>Sign up to create your Personalize view</p>
        <input type="text" v-model="email" placeholder="Email Address"><br>
        <input type="password" v-model="password" placeholder="Password"> <br>
        <button @click="signup">Sign Up</button><br>
        <span>Already have an account <router-link to="/login">login.</router-link></span>
    </div>
</template>

<script>
import firebase from 'firebase'

export default {
    name: 'signUP',
    data: function () {
        return{
            email: '',
            password: ''
        }
    },
    methods: {
      signUp: function(){
        firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
          function(user){
            alert('Your account has been created')
          },
          function(err){
            alert('Oops... ' + err.message)
          }
        );
      }
    }
}
</script>
<style scoped>
body{
  /* font-size: 1rem !important; */
}
input{
  width: 70%;
}
button{
  width: 25%;
  border-radius: 5px;
  color: white;
  /* background: #13b433; */
  background: darkgreen;
}
input, button{
  border: 2px solid darkgreen;

}
input, button, span{
  margin: 10px;
  padding: 5px;
}
.sign-up{
  margin-top:300px !important;
  margin: 0 auto;
  width: 20%;
}

</style>




// WEBPACK FOOTER //
// Signup.vue?12d4522d